import { useEffect, useState } from "react";
import packagejson from '../../../../package.json';
import LoginButton from "../appLoginComponent/loginButton"
import AppIcon from '../../../images/Final_AVIRP_Appicon.png';
import "./login.css";
import { ServerInfo } from "../../../services/ServerInfo";

type TParams = { baseName: string };

function AVEsecLogin({ baseName }: Readonly<TParams>) {

  const [forgotUsername, setForgotUsername] = useState<string>("");
  const [forgotPassword, setForgotPassword] = useState<string>("");
  const [accountRegistration, setAccountRegistration] = useState<string>("");
  const [manageMyAccount, setManageMyAccount] = useState<string>("");
  const [hostEnv, setHostEnv] = useState<string>("");


  useEffect(() => {
    rememberUrl();
    ServerInfo.get().then((environment) => {
      setForgotUsername(environment.oidcSettings.forgot_username ?? "");
      setForgotPassword(environment.oidcSettings.forgot_password ?? "");
      setAccountRegistration(environment.oidcSettings.account_registration ?? "");
      setManageMyAccount(environment.oidcSettings.manage_my_account ?? "");
      setHostEnv(environment.env);
    })

  });

  const rememberUrl = () => {
    if (!globalThis.location.href.endsWith(baseName) && !globalThis.location.href.endsWith(`${baseName}/`)) {
      sessionStorage['avirpfg_redirectURL'] = globalThis.location.href.split(baseName)[1];
    }
  }

  const getFooterText = () => {

    return (
      <tfoot style={{ fontSize: ".8rem" }}>
        <tr>
          <td style={{ fontWeight: "bold" }} className='pt-3'>
            Business Partner Helpful Links
          </td>
        </tr>
        <tr style={{ fontWeight: "bold" }}>
          <td  >
            <a className="login-link" href={forgotUsername}>Forgot Username</a> | <a className="login-link" href={forgotPassword}>Forgot Password</a>
          </td>
        </tr>
        <tr className="pt-3" style={{ fontWeight: "bold" }}>
          <td>
            <a className="login-link" href={accountRegistration}>Account Registration</a> | <a className="login-link" href={manageMyAccount}>Manage My Account</a>
          </td>
        </tr>
        <tr>
          <td style={{ fontWeight: "bold" }}>
            <div style={{ paddingTop: "20px" }}>
              Additional App Assistance
            </div>
          </td>
        </tr>
        <tr>
          <td>
            Contact PennDOT IT Service Desk
          </td>
        </tr>
        <tr style={{ fontWeight: "bold" }}>
          <td>
            <a className="login-link" href="tel:717-783-8330">717-783-8330</a> | <a className="login-link" href="tel:855-783-8330">855-783-8330</a>
          </td>
        </tr>
        <tr >
          <td style={{ fontSize: "0.7rem", paddingTop: "20px" }}>
            By Logging into this app, you are allowing PennDOT to view and monitor your actions inside of the app.
          </td>
        </tr>
      </tfoot>
    )

  }

  const onsubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
  }

  let titleWording = ""
  if (!hostEnv || hostEnv.toUpperCase() === "PROD") {
    titleWording = "AVIRP-FG Web"
  } else {
    titleWording = "AVIRP-FG Web - " + hostEnv.toUpperCase();
  }

  return (<div className="login-container">
    <form method="post" name="loginForm" className="login-form" autoComplete="off" onSubmit={onsubmit}>
      <table className="login-table">
        <tbody className="mb-5">
          <tr>
            <td>
              <img alt="App Icon" src={AppIcon} className="app-logo" />
            </td>
          </tr>
          <tr>
            <td >
              <label className="block bold font-xxl mt-2 Title">{titleWording}</label>
            </td>
          </tr>
          <tr >
            <td>
              <div className="my-10">
                <LoginButton />
              </div>
            </td>
          </tr>

        </tbody>
        {getFooterText()}
      </table>
      <div style={{ paddingTop: "20px" }}>
        <label className="block center mt-10" >Version v{packagejson.version}</label>
      </div>
    </form>
  </div>
  );


}


export default AVEsecLogin;